/*
 * @Author: Teemo Ding
 * @Date: 2021-11-16 11:05:46
 * @LastEditTime: 2022-05-18 08:45:17
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/ReturnReject/index.tsx
 */
import React, { Fragment, useState } from 'react';
import { Input, ModalFooter, TextArea } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

import css from './css.module.less';

const ReturnReject = ({ onModalCancel, onSubmit, type }) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };

  const [reason, setReason] = useState('');

  const handleOnChange = (value) => {
    setReason(value);
  };
  const handleSubmit = () => {
    onSubmit({ remark: reason, paymentReference: reason });
  };

  return (
    <Fragment>
      <div className={css.returnReject}>
        <p>
          {getI18n('allOrders.orderDetail.component_refundreject_canotundo')}
        </p>
        <h3>
          {type == 'CancelRefund'
            ? getI18n(`allOrders.orderDetail.component_refundreject_reason`)
            : type == 'rejectAdditional'
            ? getI18n(
                `allOrders.orderDetail.component_refundreject_rejectreason`,
              )
            : getI18n(
                `allOrders.orderDetail.component_refundreject_Reference`,
              )}{' '}
          ({getI18n('general.optional')})
        </h3>
        {type == 'MarkAsRefunde' || type == 'CancelRefund' ? (
          <TextArea
            autoSize={{ minRows: 3, maxRows: 3 }}
            value={reason}
            onChange={handleOnChange}
          />
        ) : (
          <Input
            size='large'
            placeholder={getI18n(
              `allOrders.orderDetail.component_refundreject_inputreason`,
            )}
            value={reason}
            onChange={handleOnChange}
          />
        )}
      </div>
      <ModalFooter
        onOk={handleSubmit}
        okText={getI18n('general.confirm')}
        onCancel={onModalCancel}
      />
    </Fragment>
  );
};

export default ReturnReject;
